<template>
  <div class="Help">
    <div class="header">
      <div class="text">
        <h1> {{ $t('MENU.TOOLTIP.HELP') }}</h1>
      </div>
    </div>

    <main>
      <iframe
        :src="urlPdf"
        frameborder="0"
        height="95%"
        width="100%"
      />
    </main>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';


export default {
  computed: {
    ...get('authModule', [
      'isLoading',
      'getUser',
    ]),

    user() {
      return this.getUser();
    },

    locale() {
      return this.user?.locale ?? 'eu';
    },

    urlPdf() {
      return `${process.env.VUE_APP_BASE_URL}/manual/manual_${this.locale}.pdf`;
    },
  },

};
</script>

<style lang="scss" scoped>
.Help {
  background: #1e282c;
  .header {
    padding-top: $theHeaderSpacing;
    background-image: url('~@/assets/images/f_home.jpg');
    background-size: cover;
    background-color: #1e282c;
    background-blend-mode: luminosity;

    .text {
      margin: 6rem auto 0rem;
      max-width: 1200px;
      padding: 0 2rem 2rem;
      h1 {
        color: white;
        text-transform: uppercase;
        font-size: $font-size-2xl;
        font-weight: bold;
        max-width: 490px;
        text-align: justify;
      }

      .subtitle {
        color: white;
        font-size: $font-size-m;
        text-align: justify;
        margin: 0.5rem 0 1rem;
        max-width: 490px;
      }
    }


  }
  main {
    padding-bottom: 2rem;

    height: 80vh;


  }
}
</style>
